"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAssetVerificationArtifacts = exports.addAssetVerificationArtifacts = void 0;
const lodash_1 = __importDefault(require("lodash"));
const uuid_1 = require("uuid");
const common_1 = require("@finley-technologies/common");
const utils_1 = require("./utils");
const { cloneDeep } = lodash_1.default;
const generateNewSlug = (assignedLoanTapeSlug, newPartialSlug) => {
    // assignedLoanTapeSlug is guaranteed to be unique for the document
    // so we can just replace the assignedLoanTape with newPartialSlug
    if (assignedLoanTapeSlug.toLowerCase().includes('assignedloantape')) {
        return assignedLoanTapeSlug.replace(/assignedLoanTape/gi, newPartialSlug);
    }
    return `${assignedLoanTapeSlug}-${newPartialSlug}`;
};
const createTape = ({ creditFacilitySlug, loanProductSlug, artifactDocumentId, assignedLoanTapeSlug, }) => {
    const documentVerificationReportSlug = generateNewSlug(assignedLoanTapeSlug, 'documentVerificationTape');
    const verificationTape = {
        id: (0, uuid_1.v4)(),
        type: 'receivableDocumentationVerificationReport',
        artifactSlug: documentVerificationReportSlug,
        configuration: {},
        loanProductSlug,
        creditFacilitySlug,
        artifactDocumentId,
        externalFilename: null,
    };
    return verificationTape;
};
// this adds synthetic record for asset verification.
// this final synthetic node goes after assignedLoanTape, and has
// creditFacilitySlug + loanProductSlug copied from
// assignedLoanTape.
//
//     * Before *
// +----------------------+           +----------------------+
// |  assignedLoanTape    +---------->|  whatever            |
// +----------------------+           +----------------------+
//
//     * After *
// +----------------------+           +----------------------+
// |  assignedLoanTape    +---------->|  whatever            |
// +----------------------+---+       +----------------------+
//                            |
//                            |
//                            |       +---------------------------------------------+
//                            +------>|  receivableDocumentationVerificationReport  |
//                                    +---------------------------------------------+
//
const addAssetVerificationArtifacts = (dbGraph) => {
    const dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    const dataTapes = cloneDeep(dbGraph.dataTapes);
    // find receivableInvoice nodes. These nodes decide
    // if the pipeline should run asset verification or not.
    const receivableInvoiceTapes = (0, utils_1.filterReceivableInvoiceTapes)({
        dataTapes,
    });
    const assignedLoanTapes = (0, utils_1.filterAssignedLoanTapes)({ dataTapes });
    receivableInvoiceTapes.forEach((receivableInvoiceTape) => {
        // get locanProductSlug and creditFacilitySlug from its configuration
        const { loanProductSlug, creditFacilitySlug, artifactDocumentId, } = receivableInvoiceTape;
        (0, common_1.finleyAssert)(loanProductSlug, `addAssetVerificationArtifacts: loanProductSlug must be defined for ${receivableInvoiceTape.artifactSlug}`);
        (0, common_1.finleyAssert)(creditFacilitySlug, `addAssetVerificationArtifacts: creditFacilitySlug must be defined for ${receivableInvoiceTape.artifactSlug}`);
        // find assignedLoanTape corresponding to this receivableInvoiceTape
        const assignedLoanTape = assignedLoanTapes.find((tape) => {
            return (tape.loanProductSlug === loanProductSlug &&
                tape.creditFacilitySlug === creditFacilitySlug);
        });
        (0, common_1.finleyAssert)(assignedLoanTape, `addAssetVerificationArtifacts: assignedLoanTape was not found for ${loanProductSlug} and ${creditFacilitySlug}`);
        // add verification tape after assigned loan tape.
        // this new node is a final node.
        const verificationTape = createTape({
            loanProductSlug,
            creditFacilitySlug,
            artifactDocumentId,
            assignedLoanTapeSlug: assignedLoanTape.artifactSlug,
        });
        dataTapes.push(verificationTape);
        dataTapeDependencies.push({
            inputArtifactId: assignedLoanTape.id,
            outputArtifactId: verificationTape.id,
        });
    });
    return { dataTapeDependencies, dataTapes };
};
exports.addAssetVerificationArtifacts = addAssetVerificationArtifacts;
// removes all receivableDocumentationVerificationReport nodes
// and any dependencies that point to them.
// basically reverse of addAssetVerificationArtifacts above.
const removeAssetVerificationArtifacts = (dbGraph) => {
    let dataTapeDependencies = cloneDeep(dbGraph.dataTapeDependencies);
    let dataTapes = cloneDeep(dbGraph.dataTapes);
    const tapeIdsToRemove = (0, utils_1.filterReceivableDocumentationVerificationReportTapes)({
        dataTapes,
    }).map(({ id }) => id);
    dataTapes = dataTapes.filter(({ id }) => !tapeIdsToRemove.includes(id));
    dataTapeDependencies = dataTapeDependencies.filter(({ outputArtifactId, inputArtifactId }) => {
        return (!tapeIdsToRemove.includes(outputArtifactId) &&
            !tapeIdsToRemove.includes(inputArtifactId));
    });
    return { dataTapeDependencies, dataTapes };
};
exports.removeAssetVerificationArtifacts = removeAssetVerificationArtifacts;
//# sourceMappingURL=assetVerification.js.map